module.exports = [{
      plugin: require('/Users/manish/Documents/fairfest/fairfest-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
